import Activity from "features/trades/TradeDrawer/Timeline/Activity";
import NewLookActivity from "features/trades/TradeDrawer/Timeline/NewLookActivity.tsx";
import { useTheme } from "styled-components";
import { getActivityColor } from "@shared/utils/charts";
import { useContext } from "react";
import { SignalDetailsContext } from "@shared/features/signals/common/SignalDetails.context";

const Timeline = () => {
  const appTheme = useTheme();
  const { pricePrecision, getSignalExtraInfoActivitiesQuery, priceCoin } =
    useContext(SignalDetailsContext)!;
  const { data } = getSignalExtraInfoActivitiesQuery;

  return (
    <div style={{ width: "100%", display: "flex" }}>
      <div style={{ flex: "auto" }}>
        {data?.map((activity, index) => {
          const { color, textColor } = getActivityColor(
            activity.activity_component,
            appTheme
          );
          if (appTheme.isNewLook) {
            return (
              <NewLookActivity
                key={index}
                activity={activity}
                color={color}
                textColor={textColor}
                pricePrecision={pricePrecision}
                priceCoin={priceCoin}
                isLast={index === data.length - 1}
              />
            );
          }
          return (
            <Activity
              key={index}
              activity={activity}
              color={color}
              textColor={textColor}
              pricePrecision={pricePrecision}
              priceCoin={priceCoin}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Timeline;
